import $ from '@rover/globals/jquery';
import moment from '@rover/globals/moment';
import Mustache from '@rover/globals/Mustache';

const RoverFullCalendarView = $.fullCalendar.views.month.class.extend({
  name: 'month',
  renderDates(...args) {
    $('.js-rover-loading', '.js-availability-calendar').remove();
    this.dayGrid.renderDayRowHtml = this.renderDayRowHtml;
    this.dayGrid.getDayClasses = this.getDayClasses;
    $.fullCalendar.views.month.class.prototype.renderDates.apply(this, args);
    $('.fc-toolbar > .fc-left').addClass('fc-title');
    $('.fc-toolbar > .fc-right').addClass('fc-buttons');
    $('.fc-toolbar > .fc-left, .fc-toolbar .fc-right').removeClass('fc-left fc-right');
    $('.fc-day.fc-sat:last, .fc-day-number.fc-sat:last').addClass('last-sat');
    $('.fc-day.fc-sun:last, .fc-day-number.fc-sun:last').addClass('last-sun');
  },
  /**
   * Override renderDayRowHtml to use tbody instead of thead, in order to be able
   * to center the numbers in the cell
   */
  renderDayRowHtml(row, isRigid) {
    const view = this.view;
    const classes = ['fc-row', 'fc-week', view.widgetContentClass];
    const numbersVisible = () => {
      if (this.numbersVisible) {
        return `<tbody>
                   ${this.renderNumberTrHtml(row)}
               </tbody>`;
      }
      return '';
    };

    if (isRigid) {
      classes.push('fc-rigid');
    }

    return `<div class="${classes.join(' ')}">
                <div class="fc-bg">
                    <table>
                        ${this.renderBgTrHtml(row)}
                    </table>
                </div>
                <div class="fc-content-skeleton">
                    <table>
                        ${numbersVisible()}
                    </table>
                </div>
            </div>`;
  },
  /**
   * Override getDayClasses to allow the roverView to add 'fc-other-month'
   * as well as add rover-has-event when a date has an event scheduled
   */
  getDayClasses(date) {
    const view = this.view;
    const today = view.calendar.getNow().stripTime();
    const classes = [
      `fc-${moment(date)
        .locale('en')
        .format('ddd')
        .toLowerCase()}`,
    ];

    if (
      (view.name === 'month' || view.name === 'rover') &&
      date.month() !== view.intervalStart.month()
    ) {
      classes.push('fc-other-month');
    }

    if (date.isSame(today, 'day')) {
      classes.push('fc-today', view.highlightStateClass);
    } else if (date < today) {
      classes.push('fc-past');
    } else {
      classes.push('fc-future');
    }

    return classes;
  },
});

export default () => {
  $.fullCalendar.views.rover = {
    class: RoverFullCalendarView,
    duration: { months: 1 },
  };
};



// WEBPACK FOOTER //
// ./js/backbone/views/mempro/fullcalendar_rover_view_init.js